export default "__VITE_ASSET__CbWk0Lwb__"